import styled from 'styled-components';
import {  Dialog,Input } from 'cdk-radial';
import {BUTTON_VARIANTS} from 'cdk-radial'
import {UserSearchWithSelectionChip} from '../../v2/dealer-admin/UserSearchWithSelectionChip';
import {useEffect, useState} from 'react';
import {
  useGetExemption,
  useSaveUserExemption
} from '../../v2/dealer-admin/useDealerAdminQueries';
import { useTranslation } from 'react-i18next';
import { IPUserExemption } from '../../v2/dealer-admin/ip-access/IPRestrictionInterface';

export const SettingDialog = styled(Dialog)`
  font-family: 'Roboto', 'Montserrat',  sans-serif;
  max-width: 50%;
  border: 1px solid gray;
  padding: 0;
  margin: 0;
  @media (max-width: 1400px) {
    min-width: 500px;
    min-height: 400px;
  }
  @media (max-width: 470px) {
    max-width: 90%;
    width: 90vw;
    min-width: 90vw;
  }
`;

export default function IPRestrictionSettingsDialog( {enterpriseId, storeId, isOpen,onClose ,openToast}: any) {

    const { data: rowData } = useGetExemption(
      enterpriseId,
      storeId
    ) as any;

    const {t} = useTranslation();
    const successMsg = t('dealer-admin.ip-access.label.savedUserExemptionMsg');
    const failureMsg = t('dealer-admin.ip-access.label.failedUserExemptionMsg');
    const [excludeUser, setExcludeUser] = useState<string[]>([]);
    const [officeInternalUrl, setOfficeInternalUrl] = useState<string>('');
    const [isSaveInProgress, setIsSaveInProgress] = useState(false);

    const { mutation: saveUserExemptionMutation } = useSaveUserExemption({
      enterpriseId,
      storeId,
      onSuccess: () => {
        setIsSaveInProgress(false);
        openToast('dealer-admin','Success',successMsg)
        onClose();
      },
      onError: () => {
        setIsSaveInProgress(false);
        openToast('dealer-admin','Error',failureMsg)
      },
    });

  useEffect(() => {
    setExcludeUser([]);
    setOfficeInternalUrl('');
  }, [storeId]);

  useEffect(()=>{
    if(rowData){
      setExcludeUser(rowData.exemptedUsers || []);
      setOfficeInternalUrl(rowData.officeInternalUrl || '');
    }
  },[rowData])

    const isValidHttpUrl = (str: string) => {
    let url;
    try {
      url = new URL(str);
    } catch {
      return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
  };

  const saveUserExemption = () =>{

    if (officeInternalUrl && officeInternalUrl?.trim().length > 0 && !isValidHttpUrl(officeInternalUrl)) {
      openToast('dealer-admin','Error',t('dealer-admin.ip-access.label.invalidOfficeInternalUrl') as string)
      return;
    }

    setIsSaveInProgress(true);

    const model = {
      exemptedUsers:excludeUser,
      officeInternalUrl: officeInternalUrl?.trim()
    } as IPUserExemption
    saveUserExemptionMutation.mutate(model);
  }

  const onDialogClose = () =>{
    setExcludeUser(rowData.exemptedUsers || []);
    setOfficeInternalUrl(rowData.officeInternalUrl || '');
    onClose();
  }

  const cancel = t('dealer-admin.ip-access.settings.cancel')
  const save = t('dealer-admin.ip-access.settings.save')
  return (
    <SettingDialog 
        id="learn-more-dialog"
        title={t('dealer-admin.ip-access.settings.title')}
        isOpen={isOpen} 
        onClose={ onDialogClose }
        disableOverlayClicked={false} 
        buttonsProps={[{
        id: 'dialog-7-action-1',
        onClick: onDialogClose,
        text: cancel,
        variant: BUTTON_VARIANTS.TEXT
        }, {
        id: 'dialog-7-action-2',
        onClick: () => { saveUserExemption()},
        text: save,
        isDisabled:isSaveInProgress,
        variant: BUTTON_VARIANTS.PRIMARY
        }]}
        >
        <div >
              <div style={{ marginTop: '20px' }}>
                  <Input
                      dataTestId="office-internal-url"
                      errorMessage=""
                      hideBorder="none"
                      iconPosition="trailing"
                      id="office-internal-url"
                      inputDivider="left"
                      label={t('dealer-admin.ip-access.label.internalUrl')}
                      name="office-internal-url"
                      onChange={(e:any)=>{setOfficeInternalUrl(e.target.value)}}
                      placeholder={t('dealer-admin.ip-access.label.internalUrlPlaceholder') as string}
                      size="standard"
                      value={ officeInternalUrl || ''}
                  />
              </div>
            
            <div style={{ marginTop: '20px' }}>
              <UserSearchWithSelectionChip 
                  excludeUser = { excludeUser }
                  onUserChanged={(userList:any)=>{
                    setExcludeUser(userList);
                  }}
                onUserAdded={(user:any)=>{
                  setExcludeUser(prev => [...prev, user]);
              }} />
            </div>
        </div>
    </SettingDialog>
  );
}
